export const FETCH_DISCOUNT = "discount/FETCH_DISCOUNT";
export const FETCH_DISCOUNT_SUCCESS = "discount/FETCH_DISCOUNT_SUCCESS";
export const FETCH_DISCOUNT_FAIL = "discount/FETCH_DISCOUNT_FAIL";
export const APPLY_DISCOUNT = "discount/APPLY_DISCOUNT";
export const REMOVE_DISCOUNT = "discount/REMOVE_DISCOUNT";
